<div
  class="collaboration-create grid grid-nogutter justify-content-center"
  [class.app-grid-fluid]="!isModalMode"
  [class.collaboration-create--modal]="isModalMode"
>
  <div class="col-12" [ngClass]="!isModalMode ? 'sm:col-10 xl:col-8' : ''" [style]="!isModalMode ? {maxWidth: '1100px'} : null">
    <form [formGroup]="form">
      <div class="grid m-0 p-1 w-100">
        <div class="col-12 lg:col-7">
          <div class="border-1 surface-border border-round mb-4">
            <span class="text-900 font-bold block border-bottom-1 surface-border p-3">
              {{ 'features.user.collaboration.create.project' | translate }}&nbsp;<span class="text-danger">*</span>
            </span>
            <div class="grid p-fluid p-2">
              <div class="col-12 mb-2">
                <p-autoComplete
                  appendTo="body"
                  formControlName="projectOption"
                  [suggestions]="filteredProjectOptions"
                  [placeholder]="'features.user.collaboration.create.project_placeholder' | translate"
                  [optionLabel]="'label'"
                  [forceSelection]="true"
                  [autofocus]="false"
                  (completeMethod)="searchProjects($event)"
                >
                  <ng-template let-projectOption pTemplate="item">
                    <div class="text-white">{{ projectOption.label }}</div>
                  </ng-template>
                  <ng-template let-projectOption pTemplate="selectedItem">
                    <span>{{ projectOption?.label }}</span>
                  </ng-template>
                  <ng-template pTemplate="loadingicon">
                    <span class="app-loading-ring" aria-hidden="true"></span>
                  </ng-template>
                </p-autoComplete>
                <div *ngIf="projectOptionControl?.invalid && projectOptionControl?.touched" class="app-form-error">
                  <p>{{ 'features.user.collaboration.create.error_required' | translate }}</p>
                </div>
              </div>
              <div class="col-12 mb-2">
                <p-dropdown
                  appendTo="body"
                  formControlName="type"
                  [options]="typeOptions"
                  optionLabel="label"
                  optionValue="value"
                  [autofocus]="false"
                  [filter]="true"
                  [showClear]="false"
                  [placeholder]="'features.user.collaboration.create.type' | translate"
                ></p-dropdown>
              </div>
            </div>
          </div>

          <div class="border-1 surface-border border-round mb-4">
            <span class="text-900 font-bold block border-bottom-1 surface-border p-3">
              {{ 'features.user.collaboration.create.title_label' | translate }}&nbsp;<span class="text-danger">*</span>
            </span>
            <div class="flex flex-column p-fluid p-2">
              <div class="mb-4 p-field p-float-label">
                <input pInputText type="text" formControlName="title" maxlength="255"/>
                <label>{{ 'features.user.collaboration.create.title_label' | translate }}&nbsp;<span class="text-danger">*</span></label>
                <div *ngIf="form.get('title').invalid && form.get('title').touched" class="app-form-error">
                  <p>{{ 'features.user.collaboration.create.error_required' | translate }}</p>
                </div>
              </div>
              <div class="mb-4 p-float-label">
                <input pInputText type="text" formControlName="shortDescription" maxlength="255"/>
                <label>{{ 'features.user.collaboration.create.description_short' | translate }}</label>
              </div>
              <div class="p-fluid p-float-label collaboration-create__textarea">
                <textarea pInputTextarea rows="5" [autoResize]="true" formControlName="description"></textarea>
                <label>{{ 'features.user.collaboration.create.description_long' | translate }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 lg:col-5">
          <div class="border-1 surface-border border-round mb-4">
            <span class="text-900 font-bold block border-bottom-1 surface-border p-3">
              {{ 'features.user.collaboration.create.service_summary' | translate }}
            </span>
            <div class="p-3">
              <ng-container *ngIf="isServiceType(selectedType); else mediaOnlyTypeInfo">
                <div class="p-fluid p-float-label mb-3 collaboration-create__textarea">
                  <textarea pInputTextarea rows="6" [autoResize]="true" formControlName="serviceSummary"></textarea>
                  <label>{{ 'features.user.collaboration.create.service_summary' | translate }}</label>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-checkbox [binary]="true" formControlName="createHistoryEntryOnApproval" inputId="historyOnApproval"></p-checkbox>
                  <label for="historyOnApproval">{{ 'features.user.collaboration.create.history_on_approval' | translate }}</label>
                </div>
                <div class="grid mt-3">
                  <div class="col-12 md:col-6">
                    <div class="p-fluid p-float-label">
                      <p-calendar appendTo="body" [showIcon]="true" [showTime]="true" dateFormat="yy-mm-dd" formControlName="historyStartDate" inputId="historyStartDate"></p-calendar>
                      <label for="historyStartDate">{{ 'shared.modal.modal_service.add_event.hour_from' | translate }}</label>
                    </div>
                  </div>
                  <div class="col-12 md:col-6">
                    <div class="p-fluid p-float-label">
                      <p-calendar appendTo="body" [showIcon]="true" [showTime]="true" dateFormat="yy-mm-dd" formControlName="historyEndDate" inputId="historyEndDate"></p-calendar>
                      <label for="historyEndDate">{{ 'shared.modal.modal_service.add_event.hour_to' | translate }}</label>
                    </div>
                  </div>
                </div>
                <div class="flex align-items-center gap-2 mt-3">
                  <p-checkbox
                    [binary]="true"
                    formControlName="initialMediaCopyDescriptionToHistoryContent"
                    inputId="initialMediaCopyDescriptionToHistoryContent"
                    (onChange)="copyInitialMediaDescriptionToHistoryContent()">
                  </p-checkbox>
                  <label for="initialMediaCopyDescriptionToHistoryContent">{{ 'features.user.collaboration.create.copy_from_description' | translate }}</label>
                </div>
                <div class="p-fluid p-float-label mt-3 collaboration-create__textarea">
                  <textarea pInputTextarea rows="5" [autoResize]="true" formControlName="initialMediaHistoryContent"></textarea>
                  <label>{{ 'feature.user.project.about.history_entry' | translate }}</label>
                </div>
              </ng-container>
              <ng-template #mediaOnlyTypeInfo>
                <p class="m-0 text-color-secondary">
                  {{ 'features.user.collaboration.create.subtitle' | translate }}
                </p>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="border-1 surface-border border-round mb-4">
            <span class="text-900 font-bold block border-bottom-1 surface-border p-3">
              {{ 'features.user.collaboration.create.initial_media' | translate }}
            </span>
            <div class="p-2 pb-0">
              <app-media-uploader #mediaUploaderComponent [currentUserVM]="currentUser" [allowFromGallery]="false"></app-media-uploader>
              <div class="p-fluid p-float-label mt-3 collaboration-create__textarea">
                <textarea pInputTextarea rows="5" [autoResize]="true" formControlName="initialMediaDescription"></textarea>
                <label>{{ 'features.user.collaboration.create.gallery_description' | translate }}</label>
              </div>
            </div>
            <small class="block pb-3 pl-3 text-color-secondary" *ngIf="mediaUploaderComponent?.newFiles?.length">
              {{ 'features.user.collaboration.create.files_selected' | translate:{count: mediaUploaderComponent.newFiles.length} }}
            </small>
          </div>
        </div>

        <div class="col-12" *ngIf="!isModalMode">
          <div class="flex justify-content-between p-1">
            <button pButton type="button" class="p-button-rounded p-button-outlined" (click)="goBack()">
              {{ 'common.button.back' | translate }}
            </button>
            <button pButton type="button" class="p-button-rounded p-button-outlined p-button-primary" [disabled]="isLoading || form.invalid" (click)="submit()">
              {{ 'features.user.collaboration.create.submit' | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
